module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/glow-bottom.97355d3f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/glow-bottom.png
// module id = 2836
// module chunks = 11